import { supo, hipNew } from '../api';
import ActionTypes from '../constants/ActionTypes';
import { getToken } from '../selectors/user';

export const fetchFeedback = async (id, refresh = false) => {
  return async (dispatch, getState) => {
    const token = getToken(getState());
    if (!refresh) {
      dispatch({
        type: ActionTypes.FETCH_FEEDBACK_REQUEST,
        payload: { id }
      });
    }
    try {
      const { data: feedback } = await supo.get(`/jobs/${id}/feedback`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      return dispatch({
        type: ActionTypes.FETCH_FEEDBACK_SUCCESS,
        payload: { id, feedback }
      });
    } catch (error) {
      return dispatch({
        type: ActionTypes.FETCH_FEEDBACK_ERROR,
        payload: { id },
        error
      });
    }
  };
};

export const fetchHipagesFeedback = async (id, refresh = false) => {
  return async (dispatch, getState) => {
    const token = getToken(getState());
    if (!refresh) {
      dispatch({
        type: ActionTypes.FETCH_FEEDBACK_REQUEST,
        payload: { id }
      });
    }
    try {
      const { data: feedback } = await supo.get(`/jobs/${id}/hipages-feedback`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      return dispatch({
        type: ActionTypes.FETCH_FEEDBACK_SUCCESS,
        payload: { id, feedback }
      });
    } catch (error) {
      return dispatch({
        type: ActionTypes.FETCH_FEEDBACK_ERROR,
        payload: { id },
        error
      });
    }
  };
};

export const sendFeedback = async (questionId, answerId, jobId, jobAssignmentId, comments) => {
  return async (dispatch, getState) => {
    const token = getToken(getState());

    try {
      const url = '/account/ajax.php';
      const config = {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          m: 'job',
          jid: jobId,
          jasid: jobAssignmentId,
          question_id: questionId,
          answer_id: answerId
        }
      };

      if (answerId) {
        const getConfig = { ...config } as any;
        getConfig.params.action = 'save_site_answer_question';
        await hipNew.get(url, config);
      }

      if (typeof comments === 'string') {
        comments = comments || '';

        const postConfig = { ...config } as any;
        postConfig.headers['Content-Type'] = 'multipart/form-data';
        postConfig.params.action = 'save_site_answer_comments';

        const formData = new FormData();
        formData.append('answer_comments', comments);
        formData.append('action', 'save_site_answer_comments');
        formData.append('jid', jobId);

        await hipNew.post(url, formData, postConfig);
      }

      dispatch({
        type: ActionTypes.UPDATE_FEEDBACK_ANSWER,
        payload: {
          questionId,
          answerId,
          jobId,
          jobAssignmentId,
          comments,
          shouldPersistLocally: true
        }
      });
    } catch (error) {
      dispatch({
        type: ActionTypes.REMOVE_FEEDBACK_ANSWER,
        payload: {
          id: jobId,
          questionId,
          jobAssignmentId,
          comments
        }
      });

      return dispatch({
        type: ActionTypes.FETCH_FEEDBACK_ERROR,
        payload: { jobAssignmentId },
        error
      });
    }
  };
};
